import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get additional questions for a given dimension
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGenerateInquiryFoundationQuestions = packet => {
  return {
    type: 'REQUEST_GENERATE_INQUIRY_FOUNDATIONS_QUESTIONS',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGenerateInquiryFoundationQuestionsSuccess = data => ({
  type: 'RECEIVE_GENERATE_INQUIRY_FOUNDATIONS_QUESTIONS_SUCCESS',
  data
})

export const receiveGenerateInquiryFoundationQuestionsFail = data => ({
  type: 'RECEIVE_GENERATE_INQUIRY_FOUNDATIONS_QUESTIONS_FAIL',
  data
})

export const tryToGenerateInquiryFoundationQuestions = packet => (dispatch, getState) => {

  dispatch(requestGenerateInquiryFoundationQuestions(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = Cookies.get(process.env.REACT_APP_COOKIE_FEATURE_SWITCH)
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/inquiries/foundations-feedback/' + packet.inquiry_id + '/' + packet.pillar + '/questions', {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGenerateInquiryFoundationQuestionsSuccess({
        request: packet,
        response: json
      }));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGenerateInquiryFoundationQuestionsFail({errors:e, lastSubmit: packet}));
    })
}
